import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import SwitchFormListItem from "../molecules/SwitchFormListItem";

interface OnlineLessonSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const OnlineLessonSettings: React.FC<OnlineLessonSettingsProps> = ({
    systemValue,
    onSave
}) => {

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="オンラインレッスン関連設定"
            />
            <List>
                <SwitchFormListItem
                    text="オンラインレッスンを有効にする"
                    initialValue={systemValue?.ENABLE_ONLINE_LESSON ? systemValue.ENABLE_ONLINE_LESSON === "ENABLE" : false}
                    onSave={value => {
                        if (onSave) {
                            onSave("ENABLE_ONLINE_LESSON", value ? "ENABLE" : "DISABLE")
                        }
                    }}
                />
            </List>
        </Paper>
    );
}

export default OnlineLessonSettings